export default "__VITE_ASSET__BRralTpU__"